export default __webpack_public_path__ + "static/media/view-affiliate.a02ba70a.svg";